import {useLayoutEffect, useState} from 'react';
import axios from "axios";
import {URL_API} from "../utils/globalConfig";
import {logError} from "../components/Utils/FormatData";
import {useDispatch} from "react-redux";
import {useAlert} from "react-alert";
import useAuthz from "./useAuthz";
import {PROFIL} from "../constants/enum";

const useAccountValidation = () => {
	const dispatch = useDispatch();
	const alert = useAlert();
	const [authz, user, profil] = useAuthz();

	useLayoutEffect(() => {
		if (profil?.profil !== PROFIL.ADMINISTRATEUR && profil?.profil !== PROFIL.GESTIONNAIRE) return;
		axios({method: 'get', url: `${URL_API}/utilisateur/nb-non-valides`})
			.then((response) => {
				dispatch({type: 'CHECK_ACCOUNTS', payload: response.data});
			})
			.catch((error) => {
				logError(alert, error);
			});
	}, [profil?.profil]);

	return null;
}

export default useAccountValidation;